<template>
    <div>
        <v-stepper
            v-model="e6"
            vertical
            class="mx-3 mt-3"
        >
            <h1 class="text-center font-weight-light">Redhead Supports Survey</h1>
            <v-divider class="ma-8"></v-divider>
            <v-stepper-step
            :complete="e6 > 1"
            step="1"
            editable
            >
            Survey Type
            <small>Affiliation</small>
            </v-stepper-step>

            <v-stepper-content step="1">
            <v-card
                class="mb-12 pl-4"
                height="auto"
                color="blue-grey lighten-5"
            >
                <v-col cols="12">
                    <h3 class="font-weight-regular">What is your affiliation with Redhead Supports?</h3>
                    <v-radio-group>
                        <v-radio label="Staff" value="Staff"></v-radio>
                        <v-radio label="Provider" value="Provider"></v-radio>
                        <v-radio label="Client" value="Client"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-card>
            <v-btn
                color="primary"
                @click="e6 = 2"
            >
                Continue
            </v-btn>
            
            </v-stepper-content>

            <v-stepper-step
            :complete="e6 > 2"
            step="2"
            editable
            >
            Quality
            </v-stepper-step>

            <v-stepper-content step="2">
            <v-card
                color="blue-grey lighten-5"
                class="mb-12"
                height="auto"
            >
                <v-col cols="12">
                    <h3 class="font-weight-regular">Rate the quality Redhead Supports?</h3>
                    <v-radio-group>
                        <v-radio label="Poor" value="Poor"></v-radio>
                        <v-radio label="Okay" value="Okay"></v-radio>
                        <v-radio label="Excellent" value="Excellent"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="4">
                    <v-textarea 
                        outlined 
                        label="Please share your thoughts"
                    ></v-textarea>
                </v-col>
            
            </v-card>
            <v-btn
                color="primary"
                @click="e6 = 3"
            >
                Continue
            </v-btn>
            
            </v-stepper-content>

            <v-stepper-step
            :complete="e6 > 3"
            step="3"
            editable
            >
            Improvements
            </v-stepper-step>

            <v-stepper-content step="3">
            <v-card
                color="blue-grey lighten-5"
                class="mb-12"
                height="auto"
            >
            
                <v-col cols="12">
                    <h3 class="font-weight-regular">Are there any improvements you think that can be made?</h3>
                    <v-radio-group>
                        <v-radio label="Yes" value="Yes"></v-radio>
                        <v-radio label="No" value="No"></v-radio>
                        <v-radio label="Everythings Great" value="Great"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="4">
                    <v-textarea 
                        outlined 
                        label="Please let us know how we can improve"
                    ></v-textarea>
                </v-col>

            </v-card>
            <v-btn
                color="primary"
                @click="e6 = 4"
            >
                Continue
            </v-btn>
            </v-stepper-content>

            <v-stepper-step step="4" editable>
            Satisfaction
            </v-stepper-step>
            <v-stepper-content step="4">
            <v-card
                color="blue-grey lighten-5"
                class="mb-12"
                height="auto"
            >
                <v-col cols="12">
                    <h3 class="font-weight-regular">Overall, how satisfied are you with our service?</h3>
                    <v-radio-group>
                        <v-radio label="Not Sure" value="Not Sure"></v-radio>
                        <v-radio label="Very Dissatisfied" value="Very Dissatisfied"></v-radio>
                        <v-radio label="Dissatisfied" value="Dissatisfied"></v-radio>
                        <v-radio label="Neutral" value="Neutral"></v-radio>
                        <v-radio label="Satisfied" value="Satisfied"></v-radio>
                        <v-radio label="Very Satisfied" value="Very Satisfied"></v-radio>
                    </v-radio-group>
                </v-col>    
            </v-card>
            <v-btn
                color="primary"
                @click="e6 = 1"
            >
                Submit
            </v-btn>
            </v-stepper-content>
        </v-stepper>
    </div>
</template>
<script>
// import Nav from '@/components/Navbar.vue'
export default {
    components: {  },
    data: () => ({
        e6: 1,
    })
}
</script>